import { render, staticRenderFns } from "./LookupArrayDisplay.vue?vue&type=template&id=9ccf42d2&scoped=true"
import script from "./LookupArrayDisplay.vue?vue&type=script&lang=js"
export * from "./LookupArrayDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccf42d2",
  null
  
)

export default component.exports